import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

type TI18nKey = string | string[]

interface ITranslationsContextType {
  translations: Map<TI18nKey, string>
  addTranslation: (key: TI18nKey, translation: string) => void
}

const I18nInterceptorContext = createContext<
  ITranslationsContextType | undefined
>(undefined)

export const I18nInterceptorProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [translations] = useState(new Map<TI18nKey, string>())

  const addTranslation = useCallback(
    (key: TI18nKey, translation: string) => {
      translations.set(key, translation)
    },
    [translations],
  )

  const values = useMemo(
    () => ({ translations, addTranslation }),
    [translations, addTranslation],
  )

  return (
    <I18nInterceptorContext.Provider value={values}>
      {children}
    </I18nInterceptorContext.Provider>
  )
}

export const useI18nInterceptor = () => {
  const context = useContext(I18nInterceptorContext)
  if (!context) {
    throw new Error(
      'useI18nInterceptor must be used within a I18nInterceptorProvider',
    )
  }
  return context
}
